import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=4a2b4b1e&"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js&"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports